import React from 'react'
import { Link } from 'react-router-dom'

export default function Strawberries() {
  return <>
      <div className="container-fluid bg-primary py-5 bg-prd14 mb-5">
      <div className="container py-5">
        <div className="row justify-content-start">
          <div className="col-lg-8 text-center text-lg-start">
            <h1 className="display-1 text-white mb-md-4">Strawberries </h1>
            <Link to="/fresh-products" className="btn btn-primary py-md-3 px-md-5 me-3">fresh products </Link>
            <Link to="" className="btn btn-secondary py-md-3 px-md-5">Strawberries </Link>
          </div>
        </div>
      </div>
    </div>

    <div className="container py-5">
      <div className='mb-5'>
        <h2 className='text-primary'> Strawberries</h2>
        <h5 className='text-muted'> Strawberries are small red fruits with a sweet and refreshing taste.
          They are known for being in season during specific times.

        </h5>
      </div>

      <h2 className='text-primary my-3'>Season:</h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>The strawberry season in Egypt typically runs from November to April. 

    </h5>
  </li>


</ul>
<hr />

      <h2 className='text-primary my-3'>Varieties:
      </h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>Festival, Fortuna , Kamarosa 

    </h5>
  </li>


</ul>
<hr />

      <h2 className='text-primary my-3'>Packing</h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>250 g 
    </h5>
  </li>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>2.5 kg carton, 10 kg carton, 25 kg carton 
    </h5>
  </li>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>10 kg net weight / carton 

    </h5>
  </li>
</ul>

<hr />

      <hr />
      <div className='my-5'>
        <i className="me-3  text-success  fa-regular fa-circle-check"></i>
        <h5 className=' d-inline mb-3'>Size:</h5>
        <h5 className=' mt-3'> 15mm ،26mm - 35mm     </h5>
        <h5 className=' mt-3'> (10 cm: 15cm – 15cm: 20cm – 20cm: 25cm  )</h5>
        <h5 className=' mt-3'> (250 g )</h5>
      </div>
      <hr />
      <hr />
      <Link to="/contact" className="btn bg-primary text-light py-3 px-5">Get Offer</Link>

    </div>
  </>
}
